import React, { useState } from "react";
import "./NewAbout.css";
import TopNav from "../components/TopNav/TopNav";
import NewHeader from "../components/NewHeader/NewHeader";
import Header from "../components/Header/Header";
import ScrolltoTop from "../components/Scrolltotop/ScrolltoTop";
import Footer from "../components/Footer/Footer";
import SamBanerDesktop from "../Assets/newAsset/aboutUs/sam.webp";
import doctor from "../Assets/newAsset/aboutUs/doctor.webp";
import heart from "../Assets/newAsset/aboutUs/heart.webp";
import MiniLogo from "../Assets/newAsset/career/minilogo.jpg";
import DnaImg from "../Assets/newAsset/aboutUs/flask.svg";
import outline from "../Assets/newAsset/aboutUs/Outline.svg";
import testTubes from "../Assets/newAsset/aboutUs/test-tube.svg";
import SimpleForm from "../components/chatbot/SimpleForm";
import micro from "../Assets/newAsset/aboutUs/micro.svg";
import pc from "../Assets/newAsset/aboutUs/dna.svg";
import research from "../Assets/newAsset/aboutUs/Group7878.svg";
import Meta from "../components/Meta";
import { Link } from "react-scroll";

//component 1
export const SingleComponent = ({
  title,
  firstPara,
  list1,
  list2,
  list3,
  list4,
  switchDiv,
  img,
}) => {
  return (
    <div className="singleComponent pl1024">
      <div
        className={switchDiv ? "componentContent switch" : "componentContent"}
      >
        <div className="ContentLeftSide">
          <h2 className="aboutUs_Heading">{title}</h2>
          <p className="aboutUsText">{firstPara}</p>
          {list1 && (
            <ul className="aboutUs_UL">
              <li>{list1}</li>
              <li>{list2}</li>
              <li>{list3}</li>
              <li>{list4}</li>
            </ul>
          )}
        </div>
        <div
          className={
            switchDiv ? "ContentRightSide imgSWitch" : "ContentRightSide"
          }
        >
          <div className="rightImg">
            <img src={img} alt="logo IMg" className="parentImg" />
            <img src={MiniLogo} alt="minilogo" className="childIMG" />
          </div>
        </div>
      </div>
    </div>
  );
};
//component 2
const SingleTwocomponent = ({
  title,
  fistpara,
  secondpara,
  list1,
  list2,
  list3,
  list4,
}) => {
  return (
    <div className="aboutDesc pl1024">
      <div className="aboutContent">
        <h2 className="aboutUs_Heading">{title}</h2>
        <p className="aboutUspara">{fistpara}</p>
        <p className="aboutUspara">{secondpara}</p>
        {list1 && (
          <ul className="aboutUs_UL">
            <li>{list1}</li>
            <li>{list2}</li>
            <li>{list3}</li>
            <li>{list4}</li>
          </ul>
        )}
      </div>
    </div>
  );
};

//card array
const cardArray = [
  {
    id: 1,
    img: DnaImg,
    title: "Biochemistry & Immunoassay",
    desc:
      "Biochemistry blood tests are performed to evaluate the efficient capacity of various critical organs and systems, like liver and kidneys. We are equipped with fully automated integrated state of the art analyzers that can share sample requiring both types of tests",
  },
  {
    id: 2,
    img: micro,
    title: "Hormone Assays",
    desc:
      "Hormonal assays are conducted to examine the metabolic processes and conditions, or ‘hormone imbalance’. It is used to measure hormones in the blood, including male and female sex hormones like oestrogen, progesterone and testosterone.",
  },
  {
    id: 3,
    img: testTubes,
    title: "Hematopathology",
    desc:
      "Hematopathology tests are performed to examine blood and blood disorders. It helps in the evaluation of blood related conditions. Our department continuously works on expanding its test menu by innovating newer assays for various serious complications and making clinical decision making easier.",
  },
  {
    id: 4,
    img: outline,
    title: "Histopathology",
    desc:
      "We are a very few labs of the country who offers a very wide range of Immunohistochemistry makers. We are equipped with an automated tissue processor, IHC stainer, LBC processing and stainer",
  },
  {
    id: 5,
    img: research,
    title: "Clinical Pathology",
    desc:
      "Clinical pathology is associated with the evaluation of diseases related to urine, blood and tissue homogenates. At Redcliffe Labs, the board-certified Phlebotomists conduct pathology tests and provide results in a thoughtful manner.",
  },
  {
    id: 6,
    img: pc,
    title: "Microbiology, Serology, and Immunology",
    desc:
      "Our departments work under the supervision of highly experienced Microbiologists and trained technical staff. We have a separate section for mycobacteriology and a BSL-2 Compliant Lab. We support our hospital clients in deciding infection control programmes and antibiotic policy.",
  },
];
function NewAbout() {
  const [seeMore, setSeemore] = useState(false);
  return (
    <>
      <Meta
        title="About Redcliffe Labs, a Team Of Pathology Experts in India"
        description="Redcliffe Labs, a one stop solution for all your Diagnostic needs, having a big Team Of Pathology Experts in India. Know more about Redcliffe Labs and our core team members."
      >
        <meta
          property="og:title"
          content="About Us - Redcliffe Labs"
        />
        <meta property="og:site_name" content="Redcliffe Labs" />
        <meta
          property="og:url"
          content="https://www.redcliffelabs.com/about-us"
        />
        <meta
          property="og:description"
          content="Redcliffe Labs is top among the reliable diagnostic centres and certified pathology labs in India. You can get the accurate reports for all the medical tests."
        />
        <meta property="og:type" content="Diagnostic Centre" />
        <meta
          property="og:image"
          content="https://redcliffelabs.com/OG-Twitter-Card.jpg"
        />

        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="Redcliffe Labs" />
        <meta
          name="twitter:title"
          content="About Us - Redcliffe Labs"
        />
        <meta
          name="twitter:description"
          content="Redcliffe Labs is top among the reliable diagnostic centres and certified pathology labs in India. You can get the accurate reports for all the medical tests."
        />
        <meta
          name="twitter:image"
          content="https://redcliffelabs.com/OG-Twitter-Card.jpg"
        />
      </Meta>
      {/* <TopNav />
      <Header /> */}
      <NewHeader faq={false} />
      <div className="aboutUsNew">
        <div className="leftSide">
          <h1>ABOUT US</h1>
          <p>Country's Fastest growing health test services</p>
        </div>
        <div className="rightSide">
          <img
            src={SamBanerDesktop}
            alt={SamBanerDesktop}
            className="img_fluid"
          />
        </div>
      </div>
      {/**  One Stop Solution for All Your Diagnostic Needs * */}
      <SingleTwocomponent
        title="One Stop Solution for All Your Diagnostic Needs"
        fistpara="We are a state-of -art diagnostic lab with complete pathology solution offering a wide range of test menu spanning over 9 major departments. At Redcliffe labs we offer:"
        // secondpara=""
        list1="Pathology Services "
        list2="Hormone Testing "
        list3="Genomic Testing "
        list4="Routine Investigations"
      />

      {/**  Team Of Pathology Experts * */}
      <SingleComponent
        title=" Team Of Pathology Experts"
        firstPara="Redcliffe Labs is headed and supervised by expert personnel of skillful and dynamic technocrats in the domain of Medicine and Pathology. Our labs are equipped with ultra modern and automatic Equipment and accessories ensuring 100% error free results."
        list1="Accuracy of test results"
        list2="Timely delivery of test reports "
        list3="Hygienic diagnostic labs"
        list4="Credibility"
        switchDiv={false}
        img={heart}
      />
      {/**  One Stop Solution for All Your Diagnostic Needs * */}
      <SingleTwocomponent
        title="Your Health Is Important To Us"
        fistpara="We help doctors and patients to plan an accurate and appropriate treatment by helping them with the right diagnosis for a particular medical condition."
        secondpara="We are available around the clock to provide our patients with highly competent, evidence-based and state-of-the-art diagnostic expertise."
      />
      {/** What Makes Us Different * */}
      <SingleComponent
        title=" What Makes Us Different"
        firstPara="We have an advanced and well-equipped testing laboratory which is built in accordance with the globally recognized standards and a competent team of highly trained experts and technologists to meet the laboratory testing requirements of our patients."
        list1="Widest network of Lab and collection centres"
        list2="3500+ routine and specialized tests "
        list3="Genetic Testing"
        list4="Team of MD Pathologists"
        switchDiv={true}
        img={doctor}
      />
      {/**  One Stop Solution for All Your Diagnostic Needs * */}
      <SingleTwocomponent
        title="COVID-19"
        fistpara="Mark yourself safe from coronavirus. We are keeping people informed about COVID-19. Coronavirus (COVID-19) testing is available at our dedicated COVID-19 collection points."
        secondpara="We are providing real-time RT-PCR and Antibody test to prevent the spread of COVID-19. Apart from this, we also provide home sample collection for COVID-19 testing."
        list1="Quick and precise reports  "
        list2="Automated labs"
        list3="Safe home sample collection "
        list4="Cost-effective"
      />
      {/**   SERVICES* */}
      <div className="services pl1024">
        <div className="services_content">
          <h2 className="aboutUs_Heading">Services you can trust</h2>
          <p className="aboutUspara">
            Redcliffe Labs provide the following clinical laboratory
            services:
          </p>

          <div className={seeMore ? "Aboutus__card expand" : "Aboutus__card"} id={seeMore ? "seeLess" :"none"}>
            {cardArray.map((values) => (
              <div className="card_Main" key={values.id}>
                <img src={values.img} alt={values.img} />
                <p className="card_HeadingAboutus">{values.title}</p>
                <p className="aboutUspara">{values.desc}</p>
              </div>
            ))}
          </div>
          <div className="viewMore">
          <Link onClick={() => setSeemore(!seeMore)}
             to="seeLess"
             offset={-110}
                smooth={true}
                duration={0}
            >

              {seeMore ? "View Less" : "View All"}
            </Link>
          </div>
        </div>
      </div>
      <div className="chatbot">
        <SimpleForm />
      </div>
      <ScrolltoTop />
      <Footer />
    </>
  );
}

export default {
  component: NewAbout,
};
